<template>
  <div id="table-wrapper">
  <table>
    <thead>
      <tr>
        <th v-for="(header, index) in headers" :key="index">
          {{ header }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in rows" :key="index">
        <td class="point" v-html="row.feature"></td>
        <td class="data">
          <img v-if="row.rare" :src="Tick" class="tick" alt="Yes icon" />
          <img v-else :src="Cross" class="tick" alt="No icon" />
        </td>
        <td class="data">
          <img v-if="row.competitor" :src="Tick" class="tick" alt="Yes icon" />
          <img v-else :src="Cross" class="tick" alt="No icon" />
        </td>
      </tr>
    </tbody>
  </table>
  </div>
</template>

<script>

import Tick from '@/assets/img/icons/tick.svg';
import Cross from '@/assets/img/icons/cross.svg';

export default {
  name: 'HomeProductsCrsTable',
  data() {
    return {
      Tick,
      Cross,
    };
  },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  table tbody, table tfoot, table thead {
    border: none;
  }

  table thead {
    border-bottom: none;
  }

  tr {
    border-bottom: 1px solid #cccccc;
  }

  table {
    border: none;
    margin: 0;
  }

  thead tr {
    background-color: #4a5b68;
    color: #ffffff;
  }

  th {
    text-align: center;
    padding: 0 0 0 22px;
  }

  th:first-of-type {
    text-align: left;
  }

  table tbody tr:nth-child(even) {
    background-color: #f5f5f5;
    border-bottom: 1px solid #cccccc;
  }

  table tbody tr:nth-child(odd) {
    background-color: #ffffff;
  }

  tr {
  }

  td {
    color: #323C44;
    font-style: normal;
    font-weight: 700;
    padding: 0 0 0 22px;
  }

  .point {
    width: 50%;
  }

  .data {
    text-align: center;
    width: 25%;
  }

  @media only screen and (min-width: 1024px) {
    #table-wrapper {

    }

    thead tr {
      font-size: 30px;
      height: 120px;
    }

    tr {
      height: 80px;
    }

    td {
      height: 80px;
      font-size: 24px;
    }

    .tick {
      width: 40px;
      height: 40px;
    }
  }

  @media only screen and (min-width: 800px) and (max-width: 1024px) {
    #table-wrapper {

    }

    thead tr {
      font-size: 14px;
      height: 60px;
    }

    tr {
      height: 40px;
    }

    td {
      height: 40px;
      font-size: 14px;
    }

    .tick {
      width: 20px;
      height: 20px;
    }
  }

  @media only screen and (max-width: 800px) {
    #table-wrapper {
      padding: 0;
    }

    table {
      border: none;
      margin: 0;
    }

    thead, th {
      border: none;
    }

    thead tr {
      font-size: 14px;
      height: 60px;
    }

    tr {
      height: 40px;
    }

    td {
      height: 40px;
      font-size: 14px;
    }

    .tick {
      width: 20px;
      height: 20px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/commonSections/RareComparisonTable.vue